import { updateProductPrice } from "./product-card-update-price";
import { dimensionTableHandler } from "./dimension-table.js";

export const observeQuickView = () => {
  if (document.documentElement.classList.contains("yith-quick-view-is-open")) {
    modifyQuickViewAsides();
    updateProductPrice();
    dimensionTableHandler();
  }

  const targetNode = document.documentElement;
  const config = { attributes: true, attributeFilter: ["class"] };

  const callback = (mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === "attributes") {
        if (
          document.documentElement.classList.contains("yith-quick-view-is-open")
        ) {
          modifyQuickViewAsides();
          dimensionTableHandler();
          jQuery(document).ready(function ($) {
            $("form.variations_form").on(
              "found_variation",
              function (event, variation) {
                if (variation && variation.price_html) {
                  $(".woocommerce-variation-price").html(variation.price_html);
                }
              }
            );
          });
        }
      }
    }
  };

  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
};

const modifyQuickViewAsides = () => {
  setTimeout(() => {
    const quickViewContent = document.querySelector(".yith-quick-view-content");

    if (quickViewContent) {
      const asideOpenElements =
        quickViewContent.querySelectorAll("[data-aside-open]");
      asideOpenElements.forEach((element) => {
        const currentValue = element.getAttribute("data-aside-open");
        if (!currentValue.includes("--quickview")) {
          element.setAttribute("data-aside-open", `${currentValue}--quickview`);
        }
      });
    }
  }, 500);
};
